import styled from 'styled-components';
import { Route } from 'react-router-dom';
import { ComponentType, ReactNode } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { BackofficePermission, useBackofficePermission } from 'hooks/useBackofficePermission';
import storageService from 'services/storage-service';

const NoPermission = styled.div`
  padding: 20px;
  font-size: 1.4rem;
`;

type WrapperProps = {
  children: ReactNode;
  permission: BackofficePermission;
};

const Wrapper = ({ children, permission }: WrapperProps) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const hasPermission = useBackofficePermission(permission);
  if (isAuthenticated) {
    if (!hasPermission) {
      return <NoPermission>You do not have permission to see this page.</NoPermission>;
    }
    return <>{children}</>;
  }
  const href = window.location.href.toLowerCase();
  if (
    href.indexOf('silent') === -1 &&
    href.indexOf('access_token=') === -1 &&
    href.indexOf('error=') === -1 &&
    href.indexOf('code=') === -1
  ) {
    storageService.set('ls.redirectPostLoginUrl', href); // save the last page
  }
  loginWithRedirect();
  return <></>;
};

// permission: the manage.rapnet permission the page needs besides signing in, or a list of which any
// one will do.
type PrivateRouteProps = {
  component: ComponentType<any>;
  path?: string;
  permission: BackofficePermission;
};

const PrivateRoute = ({ component: Component, permission, ...rest }: PrivateRouteProps) => (
  <Route {...rest}>
    <Wrapper permission={permission}>
      <Component />
    </Wrapper>
  </Route>
);

export default PrivateRoute;
